module.exports = __webpack_public_path__ + "assets/img/exit.383aeba7.svg";